import { render, staticRenderFns } from "./PatientDetails.vue?vue&type=template&id=193f8890&scoped=true"
import script from "./PatientDetails.vue?vue&type=script&lang=js"
export * from "./PatientDetails.vue?vue&type=script&lang=js"
import style0 from "./PatientDetails.vue?vue&type=style&index=0&id=193f8890&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "193f8890",
  null
  
)

export default component.exports